"use client";

import { useThemeShortcuts } from "@/hooks/use-theme-shortcuts";

export function ThemeKeyboardShortcuts() {
  useThemeShortcuts();
  return null;
}
